import { render, staticRenderFns } from "./updateHomepage.vue?vue&type=template&id=0f50b071&"
import script from "./updateHomepage.vue?vue&type=script&lang=js&"
export * from "./updateHomepage.vue?vue&type=script&lang=js&"
import style0 from "./updateHomepage.vue?vue&type=style&index=0&id=0f50b071&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports